type LocalStorageItem =
  | "machine"
  | "token"
  | "refreshToken"
  | "loginUrl"
  | "tourCompleted";

export const localStorageGet = (key: LocalStorageItem) =>
  localStorage.getItem(key);
export const localStorageSet = (key: LocalStorageItem, value: string) =>
  localStorage.setItem(key, value);
export const localStorageRemove = (key: LocalStorageItem) =>
  localStorage.removeItem(key);

// Token
export const getToken = () => localStorageGet("token");
export const removeTokens = () => {
  localStorageRemove("token");
  localStorageRemove("refreshToken");
};
